var React = require('react');

function Monetize2 (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"23","cy":"23","r":"22","fill":"#E0D6FF","key":0}),React.createElement("path",{"d":"M23 45C28.9592 45 34.365 42.6307 38.3268 38.7826C42.4427 34.7848 45 29.1911 45 23C45 10.8497 35.1503 1 23 1C10.8497 1 1 10.8497 1 23","stroke":"#5A32CA","strokeWidth":"1.91304","key":1}),React.createElement("path",{"d":"M6.22287 39.7388L19.3672 26.5945","stroke":"#5A32CA","strokeWidth":"1.91304","key":2}),React.createElement("path",{"d":"M20.4701 34.2619V25.4991H11.7072","stroke":"#5A32CA","strokeWidth":"1.91304","strokeLinejoin":"round","key":3})]);
}

Monetize2.defaultProps = {"width":"46","height":"46","viewBox":"0 0 46 46","fill":"none"};

module.exports = Monetize2;

Monetize2.default = Monetize2;
